import React from 'react';
import { Button } from '../ui/button';
import { Phone, Mail } from 'lucide-react';

const WeddingsContact = () => (
  <section className="py-16 bg-gray-50">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="text-3xl font-bold text-gray-900 mb-6">Questions About Our Wedding Packages?</h2>
      <p className="text-lg text-gray-700 mb-8">We're here to help make your special day perfect!</p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <a href="tel:+17058871864">
          <Button size="lg" variant="outline" className="border-2 border-[#FDB913]">
            <Phone className="w-5 h-5 mr-2" />
            (705) 887-1864
          </Button>
        </a>
        <a href="mailto:info@thelokal.ca">
          <Button size="lg" className="bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900">
            <Mail className="w-5 h-5 mr-2" />
            info@thelokal.ca
          </Button>
        </a>
      </div>
    </div>
  </section>
);

export default WeddingsContact;
